<template>
  <AppBtn
    v-if="isReferee"
    class="heroes-pick-reset"
    color="red-grad"
    round
    @click="resetPicks"
    >Перезапустить пики</AppBtn
  >
</template>

<script>
import { mapGetters } from "vuex";
import showAlert, { requestErrorAlert } from "@/services/common/showAlert";
import showConfirm from "@/services/common/showConfirm";
import service from "@/services/match";

export default {
  name: "HeroesPickReset",
  computed: {
    ...mapGetters("auth", ["isReferee"]),
    ...mapGetters("tournaments", ["match"])
  },
  methods: {
    async resetPicks() {
      const confirmed = await showConfirm(
        "Вы действительно хотите перезапустить пики?"
      );
      if (!confirmed) return;

      try {
        const { success, message } = await service.resetPickBans(this.match.id);
        if (!success) {
          message ? showAlert(message) : requestErrorAlert();
        }
      } catch (e) {
        console.log(e);
        requestErrorAlert();
      }
    }
  }
};
</script>

<style lang="scss">
.heroes-pick-reset {
  display: flex;
  margin: 0 auto 20px;
  width: 220px;
  max-width: 100%;
}
</style>
